module.exports = __webpack_public_path__ + "static/img/banner.372b79f8.png";